import { useCallback } from 'react';
import { getIpqsRiskContext, setIpqsRiskContext } from 'src/api/risk/ipqs-context';

interface UseIpqsReturn {
  syncDeviceResult: () => void;
  getDeviceId: () => string | undefined;
  getDeviceFraudChance: () => number | undefined;
}

interface WindowIpqsResult {
  device_id?: string;
  fraud_chance?: number;
  request_id?: string;
  guid?: string;
}

export function useIpqs(): UseIpqsReturn {
  const syncDeviceResult = useCallback(() => {
    const result = (window.__IPQS_LAST_RESULT__ ?? null) as WindowIpqsResult | null;
    if (!result) {
      return;
    }
    setIpqsRiskContext({
      deviceId: result.device_id,
      deviceFraudChance: typeof result.fraud_chance === 'number' ? result.fraud_chance : undefined,
      deviceRequestId: result.request_id,
      deviceGuid: result.guid,
    });
  }, []);

  const getDeviceId = useCallback(() => {
    syncDeviceResult();
    return getIpqsRiskContext().deviceId;
  }, [syncDeviceResult]);

  const getDeviceFraudChance = useCallback(() => {
    syncDeviceResult();
    return getIpqsRiskContext().deviceFraudChance;
  }, [syncDeviceResult]);

  return {
    syncDeviceResult,
    getDeviceId,
    getDeviceFraudChance,
  };
}
